import API from '@/lib/api';

function submitTestCode() {
  const code = document.querySelector('#input-code').value;
  const btn = document.querySelector('#checkTestCode');
    
  API.main.checkTestCode
    .call({
      code: code
    })
    .then(res => {
      redirectTo(btn?.dataset?.redirectUrl || '/');
    })
    .catch(e => {
      alert("올바르지 않은 코드입니다.");
    });
}

onload(() => {
  const input = document.querySelector('#input-code');
  const btn = document.querySelector('#checkTestCode');
  btn?.addEventListener('click', e => {
    submitTestCode()
  });
  input?.addEventListener('keyup', e => {
    if (e.keyCode == 13) submitTestCode();
    return false
  })
});